/* ==========================================================================
   Gadport — motor de movimiento
   --------------------------------------------------------------------------
   No hay librería. Son tres cosas: un observador que enciende las entradas,
   un listener de scroll para la barra de progreso y el desplazamiento del
   hero, y un partidor de palabras para los títulos.

   Dos seguros importantes:

   - Si el sistema pide menos movimiento, o el navegador no tiene
     IntersectionObserver, la capa no se enciende y la página queda quieta y
     completa. Nunca se esconde contenido que después no se pueda mostrar.
   - Igual hay un plazo de 3 segundos: pase lo que pase, todo lo que quedó
     escondido se muestra. Una animación que no dispara no puede costar una
     venta.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;

  var menosMovimiento =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (menosMovimiento || !('IntersectionObserver' in window) || root.classList.contains('gp-motion-disabled')) return;

  root.classList.add('gp-motion');

  // ------------------------------------------------------------------ grupos
  // Qué se anima y cómo. El hero queda afuera a propósito: entra con CSS al
  // cargar, sin depender del observador.
  var GRUPOS = [
    // Bloques de texto y tarjetas: suben y aparecen.
    {
      sel: '.gp-section .gp-head, .gp-section .gp-badge-wrap, ' +
           '.gp-card, .gp-shot, .gp-problem__item, .gp-problem__intro, ' +
           '.gp-trust__item, .gp-guarantee__point, .gp-faq__item, ' +
           '.gp-table tbody tr, .gp-about__body, .gp-trans__body, ' +
           '.gp-closing__inner > *, .gp-contact__item, .gp-page__body > *',
      clase: 'gp-anim'
    },
    // Imágenes que no son el hero: se destapan.
    {
      sel: '.gp-photo, .gp-about__media, .gp-card__media, .gp-shot__media',
      clase: 'gp-anim gp-anim--mask'
    },
    // El bloque negro del título de "antes y después" se pinta al entrar.
    {
      sel: '.gp-trans__title',
      clase: 'gp-anim-mark'
    },
    // La pastilla verde late una vez.
    {
      sel: '.gp-section .gp-badge',
      clase: ''
    },
    // El boton de agregar al carrito: late dos veces al aparecer y para.
    // No se le pone clase de entrada, solo se lo observa para que reciba
    // is-in: esconderlo seria perder la unica accion que importa.
    {
      sel: '#gp-submit-btn',
      clase: ''
    }
  ];

  // Cajas que forman fila o grilla. El escalón se calcula sobre estas, no
  // sobre el elemento animado: la foto de una tarjeta cuelga de SU tarjeta, y
  // contar ahí daba siempre cero, con lo cual las cuatro entraban juntas.
  var CAJAS = '.gp-card, .gp-shot, .gp-photo, .gp-problem__item, .gp-trust__item, ' +
              '.gp-guarantee__point, .gp-faq__item, .gp-contact__item, tr';

  function escalon(el) {
    var caja = el.closest ? (el.closest(CAJAS) || el) : el;
    var padre = caja.parentNode;
    if (!padre) return 0;
    var i = Array.prototype.indexOf.call(padre.children, caja);
    if (i < 0) return 0;
    return i > 7 ? 7 : i;                       // más de 8 escalones se hace lento
  }

  function preparar() {
    GRUPOS.forEach(function (g) {
      var nodos = document.querySelectorAll(g.sel);

      Array.prototype.forEach.call(nodos, function (el) {
        if (el.dataset.gpListo) return;
        el.dataset.gpListo = '1';

        if (g.clase) {
          g.clase.split(' ').forEach(function (c) { if (c) el.classList.add(c); });
        }

        el.style.setProperty('--gp-i', escalon(el));
        io.observe(el);
      });
    });
  }

  var io = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  // --------------------------------------------------------- títulos partidos
  // Solo se parten los títulos que son texto puro. Si adentro hay un <span>
  // (como el bloque negro) se deja quieto para no romper el marcado.
  function partirTitulos() {
    var titulos = document.querySelectorAll('.gp-section .gp-title');

    Array.prototype.forEach.call(titulos, function (t) {
      if (t.dataset.gpPartido || t.children.length) return;
      t.dataset.gpPartido = '1';

      var palabras = t.textContent.trim().split(/\s+/);
      if (palabras.length > 14) return;         // titulares largos: no vale la pena

      t.textContent = '';
      palabras.forEach(function (p, i) {
        var s = document.createElement('span');
        s.className = 'gp-word';
        s.style.setProperty('--gp-w', i);
        s.textContent = p;
        t.appendChild(s);
        if (i < palabras.length - 1) t.appendChild(document.createTextNode(' '));
      });

      t.classList.add('gp-anim-words');
      io.observe(t);
    });
  }

  // ------------------------------------------------- barra de progreso y hero
  var barra = null;
  var heroImg = null;

  function montarBarra() {
    var cont = document.createElement('div');
    cont.className = 'gp-progress';
    cont.setAttribute('aria-hidden', 'true');
    barra = document.createElement('div');
    barra.className = 'gp-progress__bar';
    cont.appendChild(barra);
    document.body.appendChild(cont);
  }

  var pendiente = false;

  function alScroll() {
    if (pendiente) return;
    pendiente = true;

    requestAnimationFrame(function () {
      pendiente = false;

      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || window.pageYOffset || 0;

      if (barra) {
        var p = alto > 0 ? Math.min(1, Math.max(0, y / alto)) : 0;
        barra.style.transform = 'scaleX(' + p + ')';
      }

      // Desplazamiento del hero: 6% de lo que se scrollea, con tope de 26 px.
      // Suficiente para que se note, poco para que no se despegue del texto.
      if (heroImg) {
        var d = Math.min(26, y * 0.06);
        heroImg.style.transform = 'translate3d(0,' + d.toFixed(1) + 'px,0)';
      }
    });
  }

  // ------------------------------------------------------------------- seguro
  // Si algo no disparó en 3 segundos, se muestra todo igual.
  function mostrarTodo() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.gp-anim:not(.is-in), .gp-anim-words:not(.is-in), .gp-anim-mark:not(.is-in)'),
      function (el) { el.classList.add('is-in'); }
    );
  }

  function arrancar() {
    partirTitulos();
    preparar();
    montarBarra();

    heroImg = document.querySelector('.gp-hero__media img');

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    alScroll();

    // Las secciones de Shopify pueden aparecer después del primer render.
    // Observar el DOM cubre bloques de apps y cambios del personalizador sin
    // volver a registrar listeners ni duplicar la barra de progreso.
    if ('MutationObserver' in window) {
      var mutaciones = new MutationObserver(function () {
        partirTitulos();
        preparar();
      });
      mutaciones.observe(document.body, { childList: true, subtree: true });
    }

    setTimeout(mostrarTodo, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // En el personalizador las secciones se vuelven a montar: hay que
  // re-preparar lo nuevo y mostrarlo enseguida, si no el dueño edita a ciegas.
  document.addEventListener('shopify:section:load', function () {
    partirTitulos();
    preparar();
    setTimeout(mostrarTodo, 60);
  });
})();
